module.exports = __webpack_public_path__ + "img/prove.77325c02.png";